import { RxDatabase } from 'rxdb'

export const withSuppressRxDbFreeDatabaseWarning = async (
  fn: (inMemoryMode?: boolean) => Promise<RxDatabase>,
  inMemoryMode?: boolean,
) => {
  // Suppress RxDB Dexie.js free database warning
  const originalWarn = console.warn
  console.warn = (...args: unknown[]) => {
    const message = args[0]
    if (
      typeof message === 'string' &&
      message.includes('You are using the free Dexie.js based RxStorage implementation from RxDB')
    )
      return // Suppress RxDB Dexie warning

    originalWarn.apply(console, args)
  }
  try {
    return await fn(inMemoryMode)
  } finally {
    // Restore original console.warn
    console.warn = originalWarn
  }
}
